import React from 'react';
import Slider from 'react-slick';

import './PointageSlider.scss';

import { Container, Typography } from '@design-system';
import { TaskState } from '@services';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { HoursSummed } from './HoursSummed/HoursSummed';
import { PointageItem } from './PointageItem/PointageItem';
import { PointageSliderSkeleton } from './PointageSliderSkeleton';
import { usePointageSlider } from './usePointageSlider';

export const PointageSlider: React.FC = () => {
    const { reports, isLoading, setNav1, setCurrentIndex, currentIndex, summedHours, dayToPointage } = usePointageSlider();

    if (isLoading) {
        return <PointageSliderSkeleton />;
    }

    return (
        <div className="pointage-slider">
            <Slider
                ref={(slider) => setNav1(slider)}
                slidesToShow={1}
                swipeToSlide={true}
                focusOnSelect={true}
                arrows={true}
                infinite={false}
                nextArrow={<MdKeyboardArrowRight />}
                prevArrow={<MdKeyboardArrowLeft />}
                className="week-slider"
                beforeChange={(_, next) => setCurrentIndex(next)}
                initialSlide={currentIndex}
            >
                {reports &&
                    reports.length > 0 &&
                    reports.map((report) => (
                        <div className="week-container" key={report.label}>
                            <Typography intrinsic="h2">Semaine {report.label}</Typography>
                            <Typography intrinsic="h2" variant="sub">
                                Du {new Date(report.days[0].date).toLocaleDateString()} au{' '}
                                {new Date(report.days[report.days.length - 1].date).toLocaleDateString()}
                            </Typography>
                        </div>
                    ))}
            </Slider>

            <Container greyed>
                <div className="week-days-container" key={currentIndex}>
                    {reports &&
                        reports.length > 0 &&
                        reports[currentIndex]?.days.map((day, index) => (
                            <div className="week-day-item" key={`${currentIndex}-${day.id}`} style={{ animationDelay: `${index * 0.1}s` }}>
                                <PointageItem
                                    dayId={day.id}
                                    day={(() => {
                                        const dayName = new Date(day.date).toLocaleDateString('fr-FR', {
                                            weekday: 'long'
                                        });
                                        return dayName.charAt(0).toUpperCase() + dayName.slice(1);
                                    })()}
                                    date={new Date(day.date)}
                                    optional={day.optional}
                                    state={
                                        day.tasks.some((task) => task.state_id === TaskState.REFUSED)
                                            ? TaskState.REFUSED
                                            : day.tasks.some((task) => task.state_id === TaskState.WAITING)
                                              ? TaskState.WAITING
                                              : day.tasks.reduce((acc: TaskState, { state_id }) => {
                                                    if (day.tasks.length === 0 || !state_id) {
                                                        return TaskState.EMPTY;
                                                    }
                                                    return state_id > acc ? state_id : acc;
                                                }, TaskState.EMPTY)
                                    }
                                    holidayLabel={day.holidayLabel}
                                    holiday={day.holiday}
                                    timeSpent={day.tasks.reduce((acc, task) => acc + Number(task.hours), 0)}
                                    canPointage={dayToPointage ? day.id === dayToPointage : true}
                                />
                            </div>
                        ))}
                </div>
                {reports && reports.length > 0 && <HoursSummed hours={summedHours} />}
            </Container>
        </div>
    );
};
